module.exports = __webpack_public_path__ + "img/borderLeftArrowWhite.833cb4a8.svg";